// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2P_9R","label":"Labeled_label__2jSdo","divider":"Labeled_divider__1OKi9"};